








import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class VideoBg extends Vue {
  @Prop() private msn!: any;
}
